<!--
 * @Author: wsx
 * @Date: 2022-01-06 15:48:48
 * @LastEditTime: 2022-06-14 09:45:49
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description:Table
-->
<template>
  <div
    class="HTable"
    ref="tableRefBox"
    v-loading="showLoading && loading"
    element-loading-text="Loading..."
  >
    <el-table
      class="hz-table"
      ref="tableRef"
      id="hz-table"
      v-if="tabelHeight"
      v-bind="$attrs"
      :data="tableData"
      :height="tabelHeight"
      highlight-current-row
      @select="hzTableSelect"
      @select-all="hzTableSelect"
      @sort-change="hzTableSort"
    >
      <template v-for="(item, index) in columns" :key="index">
        <!-- 复选框 -->
        <el-table-column
          :key="index"
          v-if="item.type === 'selection' && isShow(item.show)"
          type="selection"
          :selectable="selected"
          width="55"
        ></el-table-column>
        <!-- 序号 -->
        <el-table-column
          v-else-if="item.type === 'index' && isShow(item.show)"
          type="index"
          width="80"
          label="序号"
        >
          <template #default="{ $index }">
            <span>{{
              Number($index + 1) + Number((formData.page - 1) * formData.limit)
            }}</span>
          </template>
        </el-table-column>
        <!-- 具体内容 -->
        <el-table-column
          v-else-if="isShow(item.show)"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          show-overflow-tooltip
          :sortable="showSort"
        >
          <template v-slot="scope">
            <!-- 使用slot的情况下 -->
            <span v-if="item.slot">
              <!-- 具名slot -->
              <slot :name="item.slot" :row="scope.row"></slot>
            </span>
            <!-- 仅仅显示文字 -->
            <template v-else>
              <!-- 如果hidden为true的时候 那么当前格可以不显示，可以选择显示自定义的slot-->
              <!-- 操作按钮 -->
              <template v-if="item.type === 'operate'">
                <!-- <h-button
                  :disabled="disabled"
                  v-for="(operate, index) in item.operates"
                  :type="operate.type || 'primary'"
                  size="small"
                  plain
                  :key="index"
                  @click="handleClick(operate, scope.row, scope.$index)"
                  >{{ operate.name }}</h-button
                > -->
                <!-- <el-dropdown-menu>
                    <el-dropdown-item
                      v-for="(operate, index) in item.operates"
                      :key="index"
                      @click="handleClick(operate, scope.row, scope.$index)"
                    >
                      {{ operate.name }}
                    </el-dropdown-item>
                  </el-dropdown-menu> -->
                <el-dropdown>
                  <el-button
                    type="primary"
                    :style="{ width: '60px', 'text-align': 'center' }"
                  >
                    操作<el-icon class="el-icon--right">
                      <ArrowDown />
                    </el-icon>
                  </el-button>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item
                        v-for="(operate, index) in item.operates"
                        :key="index"
                        :style="{ color: operate.type === 'danger' && 'red' }"
                        @click="handleClick(operate, scope.row, scope.$index)"
                      >
                        {{ operate.name }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </template>
              <label v-else>
                <span :title="scope.row[item.prop] || '--'">{{
                  scope.row[item.prop] || "--"
                }}</span>
              </label>
            </template>
          </template>
        </el-table-column>
      </template>
      <el-table-column
        width="50"
        fixed="right"
        align="right"
        v-if="showPopover"
      >
        <template #header>
          <el-popover
            trigger="hover"
            popper-class="popoverTabel"
            placement="bottom"
            width="auto"
          >
            <div class="checkboxList">
              <template v-for="(item, index) in columnList" :key="index">
                <el-checkbox
                  v-model="item.show"
                  :label="item.label"
                  v-if="item.type !== 'operate' && item.type !== 'selection'"
                  :disabled="item.disabled"
                  @change="checkboxChange"
                  size="small"
                ></el-checkbox>
              </template>
            </div>
            <template #reference>
              <h-button
                @click="visible = true"
                size="small"
                type="text"
                icon="icon-shezhitianchong"
              />
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <!--默认的slot -->
      <slot />
    </el-table>
    <el-pagination
      ref="paginationRef"
      v-if="paging"
      v-model:currentPage="formData.page"
      v-model:page-size="formData.limit"
      :page-sizes="[20, 50, 100, 200]"
      background
      :layout="layout"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>
<script>
/**
 *
  // 表格头部配置
  columns: [
    { key: 'xxx', title: '测试' },
    { title: 'xxx', hidden: true, slot: 'demoslot'},
    {
      title: '操作', type: 'operate',
      operates: [
        {name: '详情',emitKey: 'view'}
      ]
    }
  ]
 */
import {
  defineComponent,
  onMounted,
  nextTick,
  reactive,
  toRefs,
  toRaw,
  ref,
  watch,
} from "vue";
import _ from "lodash";
import { ArrowDown } from "@element-plus/icons-vue";
export default defineComponent({
  name: "HTable",
  components: { ArrowDown },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    method: {
      type: Function,
      required: true,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    paging: {
      type: Boolean,
      default: true,
    },
    autoload: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showPopover: {
      type: Boolean,
      default: true,
    },
    showLoading: {
      type: Boolean,
      default: true,
    },
    showSort: {
      type: Boolean,
      default: false,
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next,jumper",
    },
    selectMethod: {
      // 是个方法判断行是否可选
      type: Function,
      default: () => {
        return () => {
          return false;
        };
      },
    },
  },
  emits: ["update:columns", "update:data", "handleClick", "select", "selected"],
  setup(props, { emit }) {
    const tableRef = ref(null);
    const paginationRef = ref(null);
    const tableRefBox = ref(null);
    const state = reactive({
      loading: false,
      visible: false,
      tableData: [],
      columnList: [],
      tabelHeight: undefined,
      form: {},
      formData: {
        limit: 20,
        page: 1,
      },
      total: 0,
    });
    const refData = toRefs(state);
    const initColumnList = () => {
      state.columnList = _.cloneDeep(props.columns);
      state.columnList.forEach((item) => {
        item.show = true;
      });
    };
    initColumnList();
    const handleSizeChange = (val) => {
      refresh();
    };
    const handleCurrentChange = (val) => {
      refresh();
    };
    const isShow = (v) => {
      return v === undefined ? true : v;
    };
    const checkboxChange = (v) => {
      const items = state.columnList.filter((item) => item.show);
      if (items.length === 1) {
        items[0].disabled = true;
      } else {
        state.columnList.forEach((item) => {
          item.disabled = false;
        });
      }
      emit("update:columns", state.columnList);
    };
    // 点击操作按钮
    const handleClick = (action, data, index) => {
      emit("handleClick", action, data, index);
    };
    // 刷新数据
    const refresh = async () => {
      state.loading = true;
      let params = {};
      if (props.paging) {
        params = { ...state.formData, ...toRaw(props.params) };
      } else {
        params = { ...toRaw(props.params) };
      }
      const form = _.cloneDeep(params);
      const arr = ["", null, undefined];
      for (const i in form) {
        if (arr.includes(form[i])) {
          Reflect.deleteProperty(form, i);
        }
      }
      state.form = form;
      props.method(form).then(
        (res) => {
          state.loading = false;
          state.tableData = res.page.list;
          state.total = res.page.totalCount && res.page.totalCount;
          if (res.tableInfo) {
            emit("tableInfo", res.tableInfo);
          }
        },
        () => {
          state.loading = false;
        }
      );
    };
    if (props.autoload) {
      refresh();
    }
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection, row) => {
      if (props.columns[0].value === 1) {
        console.log(props.columns[0].value, tableRef.value, "hhhhhhhhhhhhhhhh");
        tableRef.value.clearSelection();
        tableRef.value.toggleRowSelection(row);
      } else {
        emit("select", selection, row);
      }
    };
    // 排序触发
    const hzTableSort = (column, row, a) => {
      emit("sort", column, row, a);
    };
    // 清除用户勾选数据
    const clearSelection = () => {
      tableRef.value.clearSelection();
    };
    // 选择框禁选
    const selected = (row) => {
      return props.selectMethod(row);
    };
    const setTableHieght = () => {
      const pagH = paginationRef.value
        ? paginationRef.value.$el.clientHeight
        : 0;
      const boxH = tableRefBox.value.clientHeight;
      state.tabelHeight = boxH - pagH - 10;
    };
    onMounted(() => {
      nextTick(() => {
        setTableHieght();
      });
    });
    return {
      ...refData,
      isShow,
      handleSizeChange,
      handleCurrentChange,
      checkboxChange,
      hzTableSelect,
      hzTableSort,
      refresh,
      handleClick,
      tableRef,
      tableRefBox,
      paginationRef,
      clearSelection,
      selected,
      initColumnList,
    };
  },
});
</script>
<style lang="scss" scoped>
.HTable {
  height: 100%;
  width: 100%;
  @include flex-col-s-s;
  .hz-table {
    // flex: 1;
    margin-bottom: 10px;
  }
  :deep(.el-table__body-wrapper) {
    height: calc(100% - 41px);
  }
  .columnHeader {
    display: flex;
  }
}
.popoverTabel {
  max-height: 300px;
  .checkboxList {
    display: flex;
    flex-direction: column;
  }
}
</style>
<style lang="scss" >
.popoverTabel {
  max-height: 300px;
  overflow: auto;
  .checkboxList {
    display: flex;
    flex-direction: column;
  }
}
</style>
